import('./bootstrap').catch((_err) => {
  // Critical error during app bootstrap - this prevents the app from starting
  // Silent fail - bootstrap errors are handled by the module loader
})
